import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const d = {
  display: "block"
}, x = ({ size: e = 16, useVw: t, useRem: n, color: c, withColor: o, removeClassName: l, disableSSR: m, style: i, ...v }) => {
  const p = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-lianghuacelve", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), height: t ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (n ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: p, fill: "none", ...v }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: l ? "" : "32px-éåç­ç¥"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: l ? "" : "normal",
        fill: o ? r(c, 0, "#262933") : "#262933",
        datafollowfill: o ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M16 2.1a.9.9 0 0 1 .9.9v2.697c.52.099 1.028.285 1.5.558l5.85 3.377a4.8 4.8 0 0 1 2.4 4.157v6.755a4.8 4.8 0 0 1-2.4 4.157L18.4 28.08a4.8 4.8 0 0 1-4.8 0L7.75 24.7a4.8 4.8 0 0 1-2.4-4.157V13.79a4.8 4.8 0 0 1 2.4-4.157l.488-.281a.9.9 0 1 1 .9 1.559l-.488.281a3 3 0 0 0-1.5 2.598v6.755a3 3 0 0 0 1.5 2.598l5.85 3.378a3 3 0 0 0 3 0l5.85-3.378a3 3 0 0 0 1.5-2.598V13.79a3 3 0 0 0-1.5-2.598L17.5 7.814a3 3 0 0 0-3 0l-1.706.985a.9.9 0 0 1-.9-1.56l1.706-.984c.473-.273.98-.46 1.5-.558V3a.9.9 0 0 1 .9-.9ZM3 13.558a.9.9 0 0 1 .9.9v5.417a.9.9 0 1 1-1.8 0v-5.417a.9.9 0 0 1 .9-.9Zm26.9.9a.9.9 0 0 0-1.8 0v5.417a.9.9 0 1 0 1.8 0v-5.417Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M8.958 16.083a3.25 3.25 0 0 1 3.25-3.25h7.584a3.25 3.25 0 0 1 0 6.5h-7.584a3.25 3.25 0 0 1-3.25-3.25Zm3.25-1.45h7.584a1.45 1.45 0 0 1 0 2.9h-7.584a1.45 1.45 0 1 1 0-2.9Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, L = x;
export {
  L as default
};
